import { useState } from "react";
import { api } from "../api.js";
import { useLang, t, LangSwitch } from "../i18n.jsx";
import { Field } from "../shared.jsx";

// ────────────────────────────────────────────────────────────────────────
// Login — încărcat eager (importat direct din App.jsx, nu React.lazy),
// pentru că trebuie randat imediat, înainte de orice autentificare.
// ────────────────────────────────────────────────────────────────────────
export default function LoginScreen({ onLoggedIn }) {
  const { lang } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await api.login(email, password);
      onLoggedIn(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card card">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.6em" }}>
          <LangSwitch />
        </div>
        <div className="login-logo">
          <div className="mark">TSRA</div>
          <h1 style={{ marginBottom: 2 }}>TSRA</h1>
          <div style={{ color: "var(--ink-dim)", fontSize: "0.85rem" }}>Total Security Risk Assessment</div>
        </div>
        {error && <div className="error-box">{error}</div>}
        <form onSubmit={submit}>
          <Field label="Email">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <Field label="Parolă">
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </Field>
          <button className="btn btn-gold" style={{ width: "100%" }} disabled={loading}>
            {loading ? t(lang, "Se conectează…") : t(lang, "Conectare")}
          </button>
        </form>
        <div className="made-by" style={{ justifyContent: "center", marginTop: "1.6em" }}>
          Made by <b>WKC</b>
        </div>
      </div>
    </div>
  );
}
